import { useToast } from '@/features/toasts/useToast'
import { useTransferMediaOwnershipMutation } from '../api'
import type { TransferMediaOwners } from '../types'

export const useTransferMediaOwnership = () => {
  const [trigger] = useTransferMediaOwnershipMutation({
    fixedCacheKey: 'transfer-media',
  })
  const toast = useToast()

  const transferMedia = async (body: TransferMediaOwners) => {
    try {
      await trigger(body).unwrap()
      toast.success('Ownership transferred')
      return true
    } catch {
      toast.error('Failed to transfer ownership')
      return false
    }
  }

  return { transferMedia }
}
